import React from "react";
import { Link } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Card, CardContent } from "../../components/ui/card";
import { ArrowRight, CheckCircle2, Info } from "lucide-react";
import { SeoHead } from "../../seo/SeoHead";
import { buildWebSiteJsonLd, buildBreadcrumbListJsonLd } from "../../seo/site";

const SEO_TITLE = "Raguia vs Alternatives — Comparatif SaaS IA B2B";
const SEO_DESCRIPTION =
  "Comparez Raguia aux autres solutions d'IA B2B (ChatGPT Enterprise, Copilot, NotebookLM, Dust, etc.). Découvrez pourquoi les PME françaises nous choisissent.";

export default function ComparatifPage() {
  const jsonLd = [
    buildWebSiteJsonLd(),
    buildBreadcrumbListJsonLd([
      { name: "Accueil", path: "/" },
      { name: "Comparatif alternatives", path: "/comparatif" },
    ]),
  ];
  const columns = [
    "Raguia",
    "ChatGPT Ent.",
    "ChatGPT (projet)",
    "Claude (projet)",
    "Mistral (projet)",
    "NotebookLM",
    "Copilot 365",
    "Gemini WS",
    "Notion AI",
    "Dust.tt",
    "Docsbot.ai",
    "Chaindesk",
  ];

  const rows = [
    [
      "🇫🇷 Hébergement France (hors CLOUD Act)",
      "🟢 OVH FR",
      "🟡¹²",
      "🔴 US",
      "🔴 US",
      "🟢 EU",
      "🔴 US",
      "🟡¹",
      "🟡¹³",
      "🔴 US",
      "🟡 AWS EU donc CLOUD Act",
      "🔴 US",
      "🔴 US",
    ],
    [
      "🔒 LLM hors juridiction US",
      "🟢 Mistral",
      "🔴 OpenAI US",
      "🔴 OpenAI US",
      "🔴 Anthropic US",
      "🟢 Mistral EU",
      "🔴 Google US",
      "🔴 OpenAI US",
      "🔴 Google US",
      "🔴 OpenAI US",
      "🟡 US ou Mistral",
      "🔴 OpenAI US",
      "🔴 OpenAI US",
    ],
    [
      "🛡️ Données hébergées hors juridiction US (CLOUD Act)",
      "🟢",
      "🔴",
      "🔴",
      "🔴",
      "🟢",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
    ],
    [
      "🛡️ RGPD — DPA disponible",
      "🟢",
      "🟡¹²",
      "🟡²",
      "🟡²",
      "🟢",
      "🟡²",
      "🟡¹",
      "🟡¹³",
      "🟡²",
      "🟢",
      "🔴",
      "🔴",
    ],
    [
      "🏢 Isolation stricte multi-client",
      "🟢",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🟡³",
      "🟡³",
      "🟡³",
      "🟡³",
    ],
    [
      "📂 Sous-clients / départements",
      "🟢",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🟡⁴",
      "🔴",
      "🔴",
      "🔴",
    ],
    [
      "🎨 Marque blanche (logo/couleurs)",
      "🟢",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🟡⁵",
      "🟡⁵",
    ],
    [
      "📄 OCR (PDF scannés, images)",
      "🟢",
      "🟡⁶",
      "🟡⁶",
      "🟡⁶",
      "🟡⁶",
      "🟢",
      "🟢",
      "🟢",
      "🟡⁶",
      "🟡⁶",
      "🟡⁶",
      "🟡⁶",
    ],
    [
      "🖥️ Portail self-service client",
      "🟢",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🟡⁷",
      "🟡⁷",
      "🟡⁷",
    ],
    [
      "🧠 Prompt système par département",
      "🟢",
      "🟡⁸",
      "🟡⁸",
      "🟡⁸",
      "🟡⁸",
      "🔴",
      "🟡⁸",
      "🔴",
      "🔴",
      "🟢",
      "🔴",
      "🟡⁸",
    ],
    [
      "📊 Prix prévisible (forfait fixe)",
      "🟢",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🔴",
      "🟡⁹",
      "🟡⁹",
      "🟡⁹",
    ],
    [
      "🇫🇷 Support en français",
      "🟢",
      "🟡¹⁰",
      "🟡¹⁰",
      "🟡¹⁰",
      "🟢",
      "🟡¹⁰",
      "🟢",
      "🟢",
      "🟡¹⁰",
      "🟢",
      "🔴",
      "🔴",
    ],
    [
      "🚀 Clé en main (0 infra à gérer)",
      "🟢",
      "🔴¹¹",
      "🟢",
      "🟢",
      "🟢",
      "🟢",
      "🔴¹¹",
      "🔴¹¹",
      "🟢",
      "🔴¹¹",
      "🟢",
      "🟢",
    ],
    [
      "💰 Abonnement mensuel",
      "🟢 90-320 €",
      "🔴 ~30 $/user",
      "🟡 gratuit + limites",
      "🟡 gratuit + limites",
      "🟡 gratuit + limites",
      "🟡 gratuit + limites",
      "🔴 ~30 €/user + M365",
      "🔴 ~22 $/user + Workspace",
      "🟡 ~10 $/user + plan",
      "🟡 ~$29/user",
      "🟡 19-299 $",
      "🟡 25-500 $",
    ],
  ];

  return (
    <div className="bg-stone-50 font-body text-[#010101] selection:bg-[#A43032] selection:text-white min-h-screen pb-20">
      <SeoHead
        title={SEO_TITLE}
        description={SEO_DESCRIPTION}
        jsonLd={jsonLd}
      />

      {/* HEADER */}
      <section className="px-4 pt-16 pb-8 sm:px-6 lg:px-8 max-w-5xl mx-auto text-center">
        <h1 className="font-heading text-4xl sm:text-5xl font-black tracking-tight text-[#010101] mb-6">
          Raguia vs les alternatives :<br className="hidden sm:block" />{" "}
          pourquoi les PME françaises nous choisissent
        </h1>
        <p className="text-lg md:text-xl text-stone-600 font-medium max-w-3xl mx-auto">
          Comparez factuellement les solutions du marché. Contrairement aux
          grandes firmes américaines, Raguia garantit un hébergement 100%
          français, un forfait prévisible, et une isolation stricte de vos
          données.
        </p>
      </section>

      {/* TABLEAU */}
      <section className="px-4 py-8 sm:px-6 lg:px-8 max-w-[90rem] mx-auto">
        <div className="mb-4 flex items-center justify-end gap-4 text-sm font-medium text-stone-600">
          <span className="flex items-center gap-1.5">
            <span className="text-lg">🟢</span> Natif / Inclus
          </span>
          <span className="flex items-center gap-1.5">
            <span className="text-lg">🟡</span> Partiel (voir notes)
          </span>
          <span className="flex items-center gap-1.5">
            <span className="text-lg">🔴</span> Non / US
          </span>
        </div>
        <p className="mb-4 text-xs text-stone-500 text-right">
          Sur mobile: faites glisser horizontalement pour voir toutes les
          colonnes.
        </p>

        <div className="-mx-4 sm:mx-0">
          <div className="bg-white rounded-[1.5rem] border border-stone-200 shadow-xl overflow-x-auto overflow-y-hidden overscroll-x-contain [-webkit-overflow-scrolling:touch] relative">
            <table className="w-full text-left border-collapse min-w-[1500px]">
              <thead>
                <tr className="bg-stone-100/50 border-b border-stone-200">
                  <th className="p-5 font-bold text-stone-800 w-[260px] sticky left-0 bg-white z-20 border-r border-stone-200 shadow-[2px_0_5px_rgba(0,0,0,0.02)]">
                    Critere
                  </th>
                  {columns.map((column, index) => (
                    <th
                      key={column}
                      className={`p-5 min-w-[150px] text-center ${
                        index === 0
                          ? "font-black text-[#A43032] bg-[#A43032]/5 border-r border-stone-200"
                          : "font-bold text-stone-600"
                      }`}
                    >
                      {column}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody className="divide-y divide-stone-200 text-sm">
                {rows.map((row) => (
                  <tr
                    key={row[0]}
                    className="hover:bg-stone-50 transition-colors"
                  >
                    <td className="p-4 font-semibold text-stone-800 sticky left-0 bg-white z-10 border-r border-stone-200 shadow-[2px_0_5px_rgba(0,0,0,0.02)]">
                      {row[0]}
                    </td>
                    {row.slice(1).map((cell, index) => (
                      <td
                        key={`${row[0]}-${columns[index]}`}
                        className={`p-4 text-center ${
                          index === 0
                            ? "bg-[#A43032]/5 border-r border-stone-200 font-bold"
                            : "text-stone-500"
                        }`}
                      >
                        {cell}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* NOTES EXPLICATIVES */}
      <section className="px-4 py-8 sm:px-6 lg:px-8 max-w-4xl mx-auto">
        <div className="bg-white p-6 rounded-[1.5rem] border border-stone-200 shadow-lg">
          <h3 className="font-heading font-semibold text-[#010101] mb-4 flex items-center gap-2">
            <Info className="size-5 text-[#A43032]" />
            Notes explicatives concernant les concurrents
          </h3>
          <ul className="space-y-3 text-sm text-stone-600">
            <li className="flex gap-3">
              <span className="font-bold text-stone-400 shrink-0 w-6">¹</span>
              EU Data Boundary inclus pour clients EU, mais le "flexible
              routing" peut envoyer des requêtes hors EU en cas de pic de charge
              — désactivation manuelle requise par l'admin. Traitement LLM via
              Azure OpenAI = infrastructure Microsoft US soumise au CLOUD Act.
            </li>
            <li className="flex gap-3">
              <span className="font-bold text-stone-400 shrink-0 w-6">²</span>
              DPA (accord de traitement) disponible, mais l'hébergement, la
              journalisation et les sous-traitants peuvent rester partiellement
              hors EU selon le plan et les options activées.
            </li>
            <li className="flex gap-3">
              <span className="font-bold text-stone-400 shrink-0 w-6">³</span>
              Isolation par chatbot ou workspace, pas une isolation technique
              garantie multi-entreprises au sens B2B strict
            </li>
            <li className="flex gap-3">
              <span className="font-bold text-stone-400 shrink-0 w-6">⁴</span>
              Possible via configuration manuelle (spaces/workspaces), pas natif
              comme fonctionnalité produit
            </li>
            <li className="flex gap-3">
              <span className="font-bold text-stone-400 shrink-0 w-6">⁵</span>
              Marque blanche disponible uniquement sur les plans les plus élevés
              ({">"} 200 $/mois)
            </li>
            <li className="flex gap-3">
              <span className="font-bold text-stone-400 shrink-0 w-6">⁶</span>
              OCR basique via vision LLM, sans pipeline dédié ni cache — moins
              fiable sur documents complexes
            </li>
            <li className="flex gap-3">
              <span className="font-bold text-stone-400 shrink-0 w-6">⁷</span>
              Interface d'administration existe, mais non conçue pour être
              exposée à un client final
            </li>
            <li className="flex gap-3">
              <span className="font-bold text-stone-400 shrink-0 w-6">⁸</span>
              Configuration manuelle possible via instructions système, sans
              interface dédiée par département
            </li>
            <li className="flex gap-3">
              <span className="font-bold text-stone-400 shrink-0 w-6">⁹</span>
              Forfaits fixes mais limités en questions/mois ou en documents —
              coût variable à l'usage réel
            </li>
            <li className="flex gap-3">
              <span className="font-bold text-stone-400 shrink-0 w-6">¹⁰</span>
              Support disponible en français mais délais et qualité inégaux
              selon le volume de tickets
            </li>
            <li className="flex gap-3">
              <span className="font-bold text-stone-400 shrink-0 w-6">¹¹</span>
              Requiert une intégration IT, configuration des connecteurs, ou
              maintenance d'une infra cloud
            </li>
            <li className="flex gap-3">
              <span className="font-bold text-stone-400 shrink-0 w-6">¹²</span>
              ChatGPT Enterprise: résidence EU disponible uniquement pour les
              nouveaux workspaces créés après fév. 2025 ; impossible à activer
              sur un workspace existant. Le modèle LLM reste sur infrastructure
              OpenAI US soumise au CLOUD Act.
            </li>
            <li className="flex gap-3">
              <span className="font-bold text-stone-400 shrink-0 w-6">¹³</span>
              Gemini Workspace: contrôles de résidence et conformité
              disponibles, mais des flux peuvent sortir de l'EU selon la
              configuration (routage, services annexes, logs) et les options
              admin.
            </li>
          </ul>
          <p className="mt-8 text-xs text-stone-400 border-t border-stone-100 pt-4 text-center">
            Comparaison établie sur la base de données publiques. Certaines
            offres peuvent avoir évolué. Données valables au 15 avril 2026.
          </p>
        </div>
      </section>

      {/* Detailed Comparisons */}
      <section className="px-4 py-12 max-w-4xl mx-auto text-center">
        <h2 className="font-heading text-2xl font-semibold mb-6 text-stone-800">
          Comparatifs détaillés par solution
        </h2>
        <div className="flex flex-col sm:flex-row gap-4 justify-center flex-wrap">
          <Button
            asChild
            variant="outline"
            className="justify-between min-w-[280px]"
          >
            <Link to="/vs/dust">
              <span>Raguia vs Dust</span> <ArrowRight className="size-5 ml-4" />
            </Link>
          </Button>
          <Button
            asChild
            variant="outline"
            className="justify-between min-w-[280px]"
          >
            <Link to="/vs/chatgpt-enterprise">
              <span>Raguia vs ChatGPT Enterprise</span>{" "}
              <ArrowRight className="size-5 ml-4" />
            </Link>
          </Button>
          <Button
            asChild
            variant="brand"
            className="justify-between w-full sm:w-auto mt-2 sm:mt-0 min-w-[280px]"
          >
            <Link to="/blog/choisir-assistant-ia-documentaire-pme">
              <span>Guide complet : comment choisir son IA ?</span>{" "}
              <ArrowRight className="size-5 ml-4" />
            </Link>
          </Button>
        </div>
      </section>

      {/* CTA */}
      <section className="px-4 py-12 sm:px-6 lg:px-8 max-w-4xl mx-auto text-center">
        <Card className="bg-[#010101] border-0 overflow-hidden">
          <CardContent className="p-8 md:p-12 text-center relative">
            <div className="absolute inset-0 bg-gradient-to-br from-[#A43032]/30 to-transparent" />
            <h2 className="font-heading relative z-10 text-2xl md:text-3xl font-semibold text-white mb-6">
              Pour qui Raguia est-il fait ?
            </h2>
            <p className="relative z-10 text-stone-300 mb-8 max-w-2xl mx-auto">
              ChatGPT Enterprise ou Microsoft Copilot sont parfaits pour les
              grandes multinationales avec un département IT complet. Raguia est
              conçu pour les PME, cabinets RH et agences qui veulent un{" "}
              <strong>
                assistant souveraineté, à prix fixe, clé en main, prêt en 24h
              </strong>
              .
            </p>
            <Button asChild variant="brand" size="lg" className="relative z-10">
              <Link to="/contact">
                Voir une démo sur vos propres documents{" "}
                <ArrowRight className="size-5" />
              </Link>
            </Button>
            <div className="relative z-10 mt-6 flex flex-wrap justify-center gap-4 text-sm">
              <span className="flex items-center gap-1.5 text-stone-400">
                <CheckCircle2 className="size-4 text-[#A43032]" /> Démo gratuite
              </span>
              <span className="flex items-center gap-1.5 text-stone-400">
                <CheckCircle2 className="size-4 text-[#A43032]" /> Sans
                engagement
              </span>
            </div>
          </CardContent>
        </Card>
      </section>
    </div>
  );
}
